import React from "react";
import ConfirmUpgradePanel from "./ConfirmUpgradePanel";
import UserInvitationPanel from "./UserInvitationPanel";
import TwoColumnLayout from "layout/TwoColumnLayout";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import { useLoaderData } from "react-router";

interface Props {
  inviteHeaderText: string
  environment: server.dto.Environments
  viewModel: server.viewmodel.UserForInternalAdminInviteFrontModel | server.viewmodel.UserForExternalAdminInviteFrontModel
}

const UserInviteApp = (props: Props) => {
  const { viewModel } = props;

  const upgradeMessage: string | undefined = ("maximumAccounts" in viewModel) ? viewModel.maximumAccounts.upgradeMessage : undefined;

  const needsToConfirm = upgradeMessage != null;

  const [hasConfirmed, setHasConfirmed] = React.useState<boolean>(!needsToConfirm);

  const headerTitle = hasConfirmed
    ? props.inviteHeaderText
    : RESX.Subscription.resxSubscription;

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <TwoColumnLayout>
        <TwoColumnLayout.LeftColumn>
          {!hasConfirmed && <ConfirmUpgradePanel
            upgradeMessage={upgradeMessage}
            onUpgradeConfirmed={() => { setHasConfirmed(true); }}
            title={headerTitle}
          />}
          {hasConfirmed && <UserInvitationPanel
            redirectUrlWithKey={viewModel.detailUrl}
            environment={props.environment}
            title={headerTitle}
          />}
        </TwoColumnLayout.LeftColumn>
        <TwoColumnLayout.RightColumn>
          <GeneralOptionsPanel
            links={[{
              href: viewModel.listUrl,
              text: RESX.Buttons.ListView,
              visible: true
            }]}
          />
        </TwoColumnLayout.RightColumn>
      </TwoColumnLayout>
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={site.navigation.rightSideNavigation.title}
      menuItems={site.navigation.rightSideNavigation.items}
      currentPage={site.currentPage}
    />
  </TwoColumnLayout>;
};

export const UserForInternalAdminInviteApp = () => {
  const viewModel = useLoaderData<server.viewmodel.UserForInternalAdminInviteFrontModel>();

  return <UserInviteApp
    inviteHeaderText={RESX.UserType.NewInternalUser}
    environment={"internal"}
    viewModel={viewModel}
  />
}

export const UserForExternalAdminInviteApp = () => {
  const viewModel = useLoaderData<server.viewmodel.UserForExternalAdminInviteFrontModel>();

  return <UserInviteApp
    inviteHeaderText={RESX.UserType.NewExternalUser}
    environment={"external"}
    viewModel={viewModel}
  />
}